import {Button, FileInput} from "@mantine/core";
import {useContext, useState} from "react";
import QRCodeIconContext from "../../../../../../../contexts/qr-code/icon/QRCodeIconContext";
import QRCodeStyleViewContext from "../../QRCodeStyleViewContext";
import ToolBar from "../../_utils/horizontal-list-view/toolbar/ToolBar";
import Notifications from "../../../../../../../utils/notifications/Notifications";
import SubView from "../SubView";

/**
 * Upload icon view.
 * @QRCodeStyleViewTypes upload-icon
 * @author Kacper Faber
 * @since 0.1.9
*/
function UploadIconView() {
    /**
     * Icon context
     * @author Kacper Faber
     * @since 0.1.9
    */
    const iconContext = useContext(QRCodeIconContext);

    const [file, setFile] = useState<File | null>();

    /**
     * QRCodeStyleViewContext
     * @author Kacper Faber
     * @since 0.1.9
    */
    const {setActiveView} = useContext(QRCodeStyleViewContext);

    const onIconCreated = () => {
        setActiveView('more-icons');
    };

    /**
     * On submit button is clicked
     * @author Kacper Faber
     * @since 0.1.9
    */
    const onSubmitClicked = () => {
        iconContext.create({ name: file?.name ?? 'import', image: file })
            .then(onIconCreated)
            .catch(Notifications.onCreateFailed);
    };

    return (
        <SubView viewBack="more-icons">
            <ToolBar
                label="Wysyłanie ikony"
            />

            <FileInput
                onChange={setFile}
                accept="image/png,image/jpeg"
            />

            <Button
                children="ZAPISZ"
                onClick={onSubmitClicked}
                disabled={file === null || file === undefined}
            />
        </SubView>
    );
}

export default UploadIconView;

// TODO: UploadIconView.tsx
//  Improve the design